export const ROLES = {
    ADMIN: 'Admin',
    GENERAL_USER: 'General User',
    SUPER_USER: 'Super User',
    // CUSTOMER: 'Customer'
    SYSTEM_ADMIN: 'System Admin'
};

export const ROLES_ORDINAL = {
    [ROLES.SYSTEM_ADMIN]: 1,
    [ROLES.ADMIN]: 2,
    [ROLES.SUPER_USER]: 3,
    [ROLES.GENERAL_USER]: 4
}

const ROLES_FOR_SYSTEM_ADMIN = Object.values(ROLES);

const ROLES_FOR_ADMIN = ROLES_FOR_SYSTEM_ADMIN.filter(x => x !== ROLES.SYSTEM_ADMIN);

const ROLES_FOR_SUPER_USER = ROLES_FOR_ADMIN.filter(x => x !== ROLES.ADMIN);

export const ALLOWED_ROLES = {
    [ROLES.SYSTEM_ADMIN]: ROLES_FOR_SYSTEM_ADMIN,
    [ROLES.ADMIN]: ROLES_FOR_ADMIN,
    [ROLES.SUPER_USER]: ROLES_FOR_SUPER_USER,
}

export const PUBLIC_VIEW_MANAGEMENT_ROLES = [ROLES.ADMIN, ROLES.SYSTEM_ADMIN];